import script from "./TRIXIndicator.vue?vue&type=script&lang=js"
export * from "./TRIXIndicator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__